import HooksDemo from "./HooksDemo";

export default HooksDemo;
